const handlePatterns = () => {
	$('.js-pettern-save').on('click', function(event) {
		const $this = $(this);
		const $patternModal = $('.js-pattern-modal');

		localStorage.setItem('patternName', $this.data('pattern'));

		localStorage.setItem('patternHTML', $this.closest('.patterns__item').html());

		$patternModal.magnificPopup({
			type: 'inline',
			preloader: false,
			modal: true
		});

		$patternModal.magnificPopup('open');

		event.preventDefault();
	});
}

handlePatterns();

const handlePatternsWithoutModal = () => {
	$('.js-pettern-save-without-modal').on('click', function() {
		const $this = $(this);

		localStorage.setItem('patternName', $this.data('pattern'));

		localStorage.setItem('patternHTML', $this.closest('.patterns__item').html());
	});
}

handlePatternsWithoutModal();

$('.js-pattern-modal').on('mfpOpen', function(e) {
	const $modal = $.magnificPopup.instance.container;
	const $pattern = $('.js-global-patterns').find('[data-pattern="' + localStorage.getItem('patternName') + '"]').closest('.pattern');

	$pattern.clone().appendTo($modal.find('.js-pattern'));
});

$('.js-pattern-modal').on('mfpClose', function(e) {
	const $modal = $.magnificPopup.instance.container;

	$modal.find('.js-pattern').html('');

	localStorage.removeItem('patternName');

	localStorage.removeItem('patternHTML');
});
